<template>
	<div class="rp-add-minus-input w-32">
		<rp-button
			class="bg-opacity-0"
			typoColor="black"
			hoverColor="gray-300"
			@click="minusValue"
		>
			-
		</rp-button>
		<input
			type="number"
			v-model="inputValue"
			:min="min"
			:max="max"
			class="rp-add-minus-input__input border rounded py-2 text-gray-700 focus:outline-none"
			@keyup="$emit('input', Number(inputValue))"
		/>
		<rp-button
			class="bg-opacity-0"
			typoColor="black"
			hoverColor="gray-300"
			@click="addValue"
		>
			+
		</rp-button>
	</div>
</template>

<script>
import RpButton from "../components/RpButton";

export default {
	name: "RpAddRemoveButton",
	components: {
		RpButton
	},
	props: {
		value: {
			type: Number,
			default: 0
		},
		min: Number,
		max: Number
	},
	data() {
		return {
			inputValue: this.value
		};
	},
	computed: {
		inputProps() {
			return { value: this.value };
		}
	},
	watch: {
		value: function(val) {
			this.inputValue = val;
		}
	},
	methods: {
		minusValue() {
			if ((!this.min && this.min !== 0) || this.inputValue > this.min) {
				this.inputValue = this.inputValue - 1;
				this.$emit("input", this.value - 1);
			}
		},
		addValue() {
			if ((!this.max && this.max !== 0) || this.inputValue < this.max) {
				this.inputValue++;
				this.$emit("input", this.value + 1);
			}
		}
	}
};
</script>

<style>
.rp-add-minus-input__input {
	width: 3rem;
	text-align: center;
}
/* Chrome, Safari, Edge, Opera */
.rp-add-minus-input__input::-webkit-outer-spin-button,
.rp-add-minus-input__input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
.rp-add-minus-input__input[type="number"] {
	-moz-appearance: textfield;
}
</style>
